module.exports = __webpack_public_path__ + "img/new_gruop.5d11595a.png";